module.exports = __webpack_public_path__ + "img/default-profile-small.1eaebb08.png";